import React from "react";
import ReactECharts from "echarts-for-react";

export default function MonteCarloChart({ data }) {
  const { years, property, stocks } = data.timeseries;

  const series = [];

  // ===============================
  // CORES PARA OS PATHS (aleatórias ou da paleta)
  // ===============================
  const colors = [
    "#FF6B6B",
    "#4ECDC4",
    "#FFD93D",
    "#1A535C",
    "#FF6F91",
    "#6A4C93",
    "#00B8A9",
    "#F46036",
    "#2E294E",
    "#E71D36",
  ];

  // ===============================
  // ALL STOCK PATHS (alpha baixo, linhas mais grossas)
  // ===============================
  stocks.paths.forEach((path, index) => {
    series.push({
      type: "line",
      data: path,
      showSymbol: false,
      lineStyle: {
        width: 1.5, // linhas um pouco mais grossas
        opacity: 0.15,
        color: colors[index % colors.length],
      },
      animation: false,
    });
  });

  // ===============================
  // STOCK MEDIAN
  // ===============================
  series.push({
    name: "Stocks (Median)",
    type: "line",
    data: stocks.p50,
    showSymbol: false,
    lineStyle: {
      width: 3,          // linha mais grossa
      type: "dashed",    // tracejada
      color: "#00ff00",  // verde
    },
  });

  // ===============================
  // PROPERTY
  // ===============================
  series.push({
    name: "Property",
    type: "line",
    data: property,
    showSymbol: false,
    lineStyle: {
      width: 4,          // bold
      color: "#ffffff",  // branco
    },
  });

  const option = {
    backgroundColor: "transparent",
    tooltip: { trigger: "axis" },
    legend: {
      textStyle: { color: "#ccc" },
    },
    grid: {
      left: 60,
      right: 30,
      top: 50,
      bottom: 50,
    },
    xAxis: {
      type: "category",
      data: years,
      name: "Years",
      nameTextStyle: { color: "#aaa" },
      axisLine: { lineStyle: { color: "#777" } },
      splitLine: { show: false },
    },
    yAxis: {
      type: "value",
      name: "Net Worth ($)",
      nameTextStyle: { color: "#aaa" },
      axisLine: { lineStyle: { color: "#777" } },
      splitLine: {
        show: true,
        lineStyle: { color: "#666", opacity: 0.2 },
      },
    },
    series,
  };

  return <ReactECharts option={option} style={{ height: 500, width: "100%" }} />;
}
